export enum ApiRoutes {
  submitForm = "/api/submit-form/",
  hubspotForms = "/api/hubspot/forms/",
  strapiBlogs = "/api/strapi/blogs/",
  strapiCaseStudies = "/api/strapi/case-studies/",
  strapiNewsEvents = "/api/strapi/news-and-events/",
}
